export const environment = {
    production: true,
    basePath: 'http://SRVANMID01T/brd-namirial-api/api',
    apiVersion: 'v1'
};
